// LoadingScreen.js
import React from "react";
import "./LoadingScreen.scss";
import { PropagateLoader } from "react-spinners"; // Import the loader

const LoadingScreen = () => (
  <div className="loading-screen">
    <div className="loading-message bounce-text">
      <h1 className="loader-text">Loading...</h1>
      <PropagateLoader color="#8ad5ff" size={15} speedMultiplier={1} />
    </div>
  </div>
);

export default LoadingScreen;
